var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('MainSidebar',{attrs:{"menu-items":_vm.menuItems}}),_c('el-container',{staticClass:"main-container",attrs:{"direction":"vertical"}},[(_vm.$route.name !== 'postLogin')?_c('MainHeader'):_vm._e(),_c('el-main',{class:[
        'main',
        { 'main--has-fab': !!this.$route.meta.hasFloatingActionButton },
        { 'main--has-background': _vm.$route.name === 'postLogin' },
      ],style:({
        backgroundImage:
          _vm.$route.name === 'postLogin'
            ? `url(${require('@/assets/images/background_preLogin.png')})`
            : '',
      })},[_c('el-container',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }